import { render, staticRenderFns } from "./BrandMessage.vue?vue&type=template&id=5d2147b0&lang=pug&"
import script from "./BrandMessage.vue?vue&type=script&lang=js&"
export * from "./BrandMessage.vue?vue&type=script&lang=js&"
import style0 from "./BrandMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d2147b0')) {
      api.createRecord('5d2147b0', component.options)
    } else {
      api.reload('5d2147b0', component.options)
    }
    module.hot.accept("./BrandMessage.vue?vue&type=template&id=5d2147b0&lang=pug&", function () {
      api.rerender('5d2147b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/BrandMessage.vue"
export default component.exports